export default "__VITE_ASSET__D0T2$8dw__"